
    const original = "<svg\n   width=\"20\"\n   height=\"20\"\n   viewBox=\"0 0 20 20.000001\"\n   version=\"1.1\"\n   id=\"svg1\"\n   xmlns=\"http://www.w3.org/2000/svg\"\n   xmlns:svg=\"http://www.w3.org/2000/svg\">\n  <defs\n     id=\"defs1\" />\n  <g\n     id=\"g7\">\n    <path\n       style=\"fill:#855cd6;fill-opacity:1;stroke:none;stroke-width:0;stroke-linecap:round;stroke-dasharray:none;stroke-opacity:1\"\n       id=\"path7\"\n       d=\"M 83.628796,0.5837816 77.643687,15.033113 63.194355,21.018222 48.745023,15.033113 42.759914,0.5837816 48.745023,-13.86555 l 14.449332,-5.985109 14.449332,5.985109 z\"\n       transform=\"matrix(-0.48936989,-0.20270364,0.20270364,-0.48936989,40.80708,23.095411)\" />\n  </g>\n</svg>\n";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
